import DebounceLink from 'apollo-link-debounce';

const DEFAULT_DEBOUNCE_TIMEOUT = 300;

export const debounceLink = new DebounceLink(DEFAULT_DEBOUNCE_TIMEOUT);

/// <reference types="@apollo/client" />
declare module '@apollo/client' {
  interface DefaultContext {
    /**
     * If provided, all operations with the same key will be debounced together.
     * That is, if more than one operation with the same key is issued within the
     * timeout, only the last will actually be sent to the network, while the
     * others are dropped.
     *
     * @see https://www.npmjs.com/package/apollo-link-debounce
     */
    debounceKey?: string;

    /**
     * If provided, override the debounce timeout for this operation. Only takes
     * effect if {@link debounceKey} is provided.
     *
     * @see https://www.npmjs.com/package/apollo-link-debounce
     */
    debounceTimeout?: number;
  }
}
